import {
  GenerateRebalancingPlanCombinedParams,
  GenerateRebalancingPlanParams,
} from '@cast/types';

export const mapCombinedCreateRebalancingPlanParamsToRegularPlanParams = (
  params: GenerateRebalancingPlanCombinedParams
): GenerateRebalancingPlanParams => {
  return {
    minNodes: params.minNodes,
    evictGracefully: params.evictGracefully,
    aggressiveModeConfig: params.aggressiveModeConfig,
    maxSimultaneousDrains: params.maxSimultaneousDrains,
    splitNodesInBatchesOf: params.splitNodesInBatchesOf,
    rebalancingNodes: params.rebalancingNodes,
  };
};
